import template from './commercial-building-status.jade';
import commercialBuildingStatusOptions from '../../../enums/building-status-type-default';

export default angular
    .module('cian.addForm.commercialBuildingStatus', [])
    .directive('cianAfAboutBuildingCommercialBuildingStatus', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
          'ngInject';

          this.isMobile = deviceService.isMobile;

          this.options = commercialBuildingStatusOptions;
        },
        controllerAs: 'commercialBuildingStatus',
        template,
    }))
    .name;
